import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { userInfoReducer } from 'app/core/store/user/reducers/user-info.reducer';
import { commentReducer } from 'app/core/store/user/reducers/comment.reducer';
import { CommentState } from 'app/core/store/user/state/comment.state';
import { transactionActiveStatusReducer } from 'app/core/store/user/reducers/transaction-active-status.reducer';
import { TransactionActiveStatusState } from 'app/core/store/user/state/transaction-active-status.state';
import { TransactionsActionsState } from 'app/core/store/user/state/transactions-actions.state';
import { transactionActionsReducer } from 'app/core/store/user/reducers/transaction-actions.reducer';
import { StaticTransactionsDataState } from 'app/core/store/user/state/static-transactions-data.state';
import { staticTransactionsDataReducer } from 'app/core/store/user/reducers/static-transactions-data.reducer';
import { TransactionStatusState } from 'app/core/store/user/state/transaction-status.state';
import { transactionStatusReducer } from 'app/core/store/user/reducers/transaction-status.reducer';
import { StaticUserDataState } from 'app/core/store/user/state/static-user-data.state';
import { staticUserDataReducer } from 'app/core/store/user/reducers/static-user.data.reducer';
import { TransactionStatusDateState } from 'app/core/store/user/state/transaction-status-date.state';
import { transactionStatusDateReducer } from 'app/core/store/user/reducers/transaction-status-date.reducer';
import { TransactionTabState } from 'app/core/store/user/state/transaction-tab.state';
import { transactionTabReducer } from 'app/core/store/user/reducers/transaction-tab.reducer';
import { MerchantState } from 'app/core/store/user/state/merchant.state';
import { merchantActionReducer } from 'app/core/store/user/reducers/merchant.reducer';
import { TransactionFailReasonState } from '../core/store/user/state/transaction-fail-reason.state';
import { transactionFailReasonReducer } from '../core/store/user/reducers/transaction-fail-reason.reducer';
import { WithdrawCommentState } from 'app/core/store/user/state/withdraw-comment.state';
import { WithdrawCommentReducer } from 'app/core/store/user/reducers/withdraw-comment.reducer';
import { UserVerificationState } from 'app/core/store/user/state/verification.state';
import { userVerificationReducer } from 'app/core/store/user/reducers/verifications.reducer';
import { AlertState } from 'app/core/store/user/state/alert.state';
import { alertReducer } from 'app/core/store/user/reducers/alert.reducer';

export interface AppState {
    userRoles: any;
    comments: CommentState;
    transactionActiveStatus: TransactionActiveStatusState;
    transactionActions: TransactionsActionsState;
    staticTransactionData: StaticTransactionsDataState;
    transactionStatus: TransactionStatusState;
    staticUserData: StaticUserDataState;
    transactionStatusDates: TransactionStatusDateState;
    transactionTab: TransactionTabState;
    merchant: MerchantState;
    failReasonStatus: TransactionFailReasonState;
    withdrawComments: WithdrawCommentState;
    verification: UserVerificationState;
    alert: AlertState;
}

export const reducers: ActionReducerMap<AppState> = {
    userRoles: userInfoReducer,
    comments: commentReducer,
    transactionTab: transactionTabReducer,
    transactionActiveStatus: transactionActiveStatusReducer,
    transactionActions: transactionActionsReducer,
    staticTransactionData: staticTransactionsDataReducer,
    transactionStatus: transactionStatusReducer,
    staticUserData: staticUserDataReducer,
    transactionStatusDates: transactionStatusDateReducer,
    merchant: merchantActionReducer,
    failReasonStatus: transactionFailReasonReducer,
    withdrawComments: WithdrawCommentReducer,
    verification: userVerificationReducer,
    alert: alertReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
    ? []
    : [];
